import { useEffect } from 'react'
import { checkIfAnyDropdownIsOpen, checkIfAnyModalIsOpen } from '../../../../../utils/antd.helper'

const useTextSubmissionNavigationShortcuts = (
    submissions,
    openedSubmissionId,
    navigateToPreviousSubmission,
    navigateToNextSubmission,
) => {
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown, true)
        return () => document.removeEventListener('keydown', handleKeyDown, true)
    }, [submissions, openedSubmissionId])

    const handleKeyDown = event => {
        if (checkIfAnyModalIsOpen() || checkIfAnyDropdownIsOpen()) return
        if (['INPUT', 'TEXTAREA'].includes(document.activeElement.nodeName)) return // To not trigger when wanting to move between characters in input and not submissions
        if (document.activeElement.className.includes('DragHandle')) return
        if (event.key === 'ArrowLeft') {
            navigateToPreviousSubmission()
        } else if (event.key === 'ArrowRight') {
            navigateToNextSubmission()
        }
    }
}

export default useTextSubmissionNavigationShortcuts
